/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Metadata_Scan_TitleInputs */



/**
* | output |
* | --- |
* | "Media Metadata Scan" |
*
* @param {Media_Import_Metadata_Scan_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_metadata_scan_title = /** @type {((inputs?: Media_Import_Metadata_Scan_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Metadata_Scan_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Analyse des metadonnees du media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienmetadaten-Scan")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansione dei metadati multimediali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сканирование метаданных медиафайлов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escaneo de metadatos de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体元数据扫描")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアメタデータスキャン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया मेटाडेटा स्कैन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Análise de metadados de mídia")
	return /** @type {LocalizedString} */ ("Media Metadata Scan")
});